import React, { useState } from "react";
import CrudModule from "@/components/admin/CrudModule";
import { Badge } from "@/components/common/Primitives";
import { forumsCrud, forumPostsCrud } from "@/services/forumsService";
import { storageService } from "@/services/storageService";

const FORUM_OPTIONS = ["socio-civic-political", "environment", "youth-training"];

export default function AdminForumsPage() {
  const [tab, setTab] = useState("posts");

  return (
    <div data-testid="admin-forums-page">
      <div className="flex gap-2 mb-6">
        {[
          { id: "posts", label: "Forum Posts" },
          { id: "forums", label: "Forum Settings" },
        ].map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
              tab === t.id ? "bg-maroon text-white" : "bg-white border border-gray-200 text-ink-soft hover:text-maroon"
            }`}
            data-testid={`forums-tab-${t.id}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === "posts" ? (
        <CrudModule
          title="Forum Posts"
          description="Updates, campaigns and achievements published on the three forum pages."
          crud={forumPostsCrud}
          searchKeys={["title", "forum_slug", "post_type"]}
          columns={[
            { key: "title", label: "Title" },
            { key: "forum_slug", label: "Forum", render: (r) => <Badge tone="maroon">{r.forum_slug}</Badge> },
            { key: "post_type", label: "Type" },
            { key: "created_at", label: "Date", render: (r) => String(r.created_at || "").slice(0, 10) },
          ]}
          toggles={[
            { key: "is_published", label: "Published" },
            { key: "is_featured", label: "Featured" },
          ]}
          fields={[
            { name: "title", label: "Title", type: "text", required: true },
            { name: "forum_slug", label: "Forum", type: "select", options: FORUM_OPTIONS, required: true },
            { name: "post_type", label: "Type", type: "select", options: ["update", "campaign", "achievement"], required: true },
            {
              name: "image_url",
              label: "Image",
              type: "image",
              onUpload: (file, hint) => storageService.uploadForumPostImage(file, hint),
              folderLabel: "forum_post",
              nameHintFrom: "title",
            },
            { name: "excerpt", label: "Excerpt", type: "textarea" },
            { name: "body", label: "Body", type: "textarea", required: true },
            { name: "is_published", label: "Published", type: "checkbox", default: true },
            { name: "is_featured", label: "Featured", type: "checkbox", default: false },
          ]}
        />
      ) : (
        <CrudModule
          title="Forums"
          description="The three BCS forums — edit names, taglines, descriptions and hero imagery."
          crud={forumsCrud}
          searchKeys={["name", "slug"]}
          columns={[
            { key: "name", label: "Forum" },
            { key: "tagline", label: "Tagline" },
            { key: "sort_order", label: "Order" },
          ]}
          toggles={[{ key: "is_published", label: "Published" }]}
          fields={[
            { name: "name", label: "Name", type: "text", required: true },
            { name: "slug", label: "Slug", type: "text", required: true, hint: "Used in the URL, e.g. environment" },
            { name: "tagline", label: "Tagline", type: "text" },
            {
              name: "hero_image",
              label: "Hero Image",
              type: "image",
              onUpload: (file, hint) => storageService.uploadForumImage(file, hint),
              folderLabel: "forum",
              nameHintFrom: "slug",
            },
            { name: "description", label: "Description", type: "textarea", required: true },
            { name: "focus_areas", label: "Focus Areas (JSON array)", type: "json", hint: 'e.g. ["Voter registration", "Legal aid"]' },
            { name: "sort_order", label: "Sort Order", type: "number" },
            { name: "is_published", label: "Published", type: "checkbox", default: true },
          ]}
        />
      )}
    </div>
  );
}
